import { supabase } from "@/integrations/supabase/client";

export interface BookingFailureInput {
  userId?: string | null;
  clientName?: string | null;
  clientEmail?: string | null;
  clientPhone?: string | null;
  bookingDate?: string | null;
  bookingTime?: string | null;
  serviceName?: string | null;
  serviceCategory?: string | null;
  addons?: string[] | null;
  price?: number | null;
  /** Where in the flow it broke: blocked_slot | insert | checkout | payment */
  stage: string;
  reason: string;
  errorCode?: string | null;
  metadata?: Record<string, unknown>;
}

/**
 * Best-effort log of a failed booking attempt. Never throws — a logging
 * failure must never mask the original error shown to the client.
 */
export async function logBookingFailure(input: BookingFailureInput): Promise<void> {
  try {
    await (supabase.from("booking_failures") as any).insert({
      user_id: input.userId ?? null,
      client_name: input.clientName ?? null,
      client_email: input.clientEmail ?? null,
      client_phone: input.clientPhone ?? null,
      booking_date: input.bookingDate ?? null,
      booking_time: input.bookingTime ?? null,
      service_name: input.serviceName ?? null,
      service_category: input.serviceCategory ?? null,
      addons: input.addons?.length ? input.addons.join(", ") : null,
      price: input.price ?? null,
      stage: input.stage,
      reason: (input.reason || "Unknown error").slice(0, 500),
      error_code: input.errorCode ?? null,
      source: "client",
      metadata: input.metadata ?? {},
    });
  } catch (err) {
    console.error("[booking-failure-log] failed:", err);
  }
}
